var map = {
	"./adminprofile/add": [
		1947,
		15
	],
	"./agentprofile/add": [
		1948,
		18
	],
	"./ai_assistant/add": [
		1949,
		21
	],
	"./api_key/add": [
		1950,
		24
	],
	"./canned_answer/add": [
		1951,
		29
	],
	"./client/add": [
		1952,
		32
	],
	"./disposition/add": [
		1953,
		37
	],
	"./field/add": [
		1954,
		40
	],
	"./form/add": [
		1955,
		43
	],
	"./form_website/add": [
		1956,
		46
	],
	"./invoice_post/add": [
		1957,
		53
	],
	"./journey/add": [
		1958,
		56
	],
	"./journey_draft/add": [
		1959,
		59
	],
	"./journey_variable/add": [
		1960,
		63
	],
	"./list/add": [
		1961,
		66
	],
	"./list_file/add": [
		1962,
		69
	],
	"./mail_account/add": [
		1963,
		72
	],
	"./operational_hours/add": [
		1964,
		75
	],
	"./organization/add": [
		1965,
		78
	],
	"./pause/add": [
		1966,
		81
	],
	"./phonenumber_monthly_cost/add": [
		1967,
		84
	],
	"./phonenumber_monthly_cost_parent/add": [
		1968,
		87
	],
	"./phonenumber_purchase/add": [
		1969,
		91
	],
	"./phonenumber_setup_cost/add": [
		1970,
		94
	],
	"./phonenumber_setup_cost_parent/add": [
		1971,
		97
	],
	"./prepaid_credit/add": [
		1972,
		104
	],
	"./queue/add": [
		1973,
		107
	],
	"./signature/add": [
		1974,
		111
	],
	"./skill/add": [
		1975,
		114
	],
	"./sla_policy/add": [
		1976,
		117
	],
	"./sound/add": [
		1977,
		120
	],
	"./stats_alarm/add": [
		1978,
		123
	],
	"./stats_custom_metric/add": [
		1979,
		126
	],
	"./stats_report/add": [
		1980,
		129
	],
	"./stats_widget/add": [
		1981,
		132
	],
	"./superadmin_profile/add": [
		1982,
		135
	],
	"./tag/add": [
		1983,
		138
	],
	"./tariff/add": [
		1984,
		141
	],
	"./tariff_parent/add": [
		1985,
		144
	],
	"./team/add": [
		1986,
		147
	],
	"./text_message_source/add": [
		1987,
		9
	],
	"./time_interval/add": [
		1988,
		151
	],
	"./user/add": [
		1989,
		154
	],
	"./voice_asterisk/add": [
		1990,
		157
	],
	"./voice_asterisk_downgrade/add": [
		1991,
		160
	],
	"./voice_route/add": [
		1992,
		167
	],
	"./voice_shortcut/add": [
		1993,
		170
	],
	"./voice_trunk/add": [
		1994,
		173
	],
	"./voice_voicemail/add": [
		1995,
		176
	],
	"./wallboard/add": [
		1996,
		179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1868;
module.exports = webpackAsyncContext;